<main class="min-h-dvh flex flex-col pb-4 pt-12">
  <app-header></app-header>
  <div class="row flex flex-1 justify-center">
    <div class="container rounded-md shadow-lg mt-5 bg-white p-4 justify-center h-fit">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</main>
